import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';

import { ClinicDistance } from '@src/pages/api/distances.page';

export type FlowTypes = 'SS_BOOK_AHEAD' | 'SS_KIOSK';

type State = {
	urgentCareCentersLink: string;
	training: boolean;
	featureFlags: Record<string, unknown>;
	flowType: FlowTypes;
	distances: Record<string, ClinicDistance[]>;
};

type Actions = {
	setUrgentCareCentersLink: (url: string) => void;
	setTrainingStatus: (training: boolean) => void;
	setFeatureFlags: (featureFlags: Record<string, unknown>) => void;
	setFlowType: (val: FlowTypes) => void;
	setDistances: (val: Record<string, ClinicDistance[]>) => void;
};

const useAppStore = create<State & Actions>((set) => ({
	urgentCareCentersLink: '',
	training: false,
	featureFlags: {},
	flowType: 'SS_BOOK_AHEAD',
	distances: {},
	setUrgentCareCentersLink: (urgentCareCentersLink) => set({ urgentCareCentersLink }),
	setTrainingStatus: (training) => set(() => ({ training })),
	setFeatureFlags: (featureFlags) => set({ featureFlags }),
	setFlowType: (flowType) => set({ flowType }),
	setDistances: (distances) => set({ distances }),
}));

if (process.env.NODE_ENV === 'development') {
	mountStoreDevtool('appStore', useAppStore);
}

export default useAppStore;
